import Footer from '../../sections/footer/Footer'
import BackToTopButton from '../../components/backToTopButton/BackToTopButton'
import HeaderSolid from '../../sections/header/HeaderSolid'

import './style.scss'
import { useEffect, useState } from 'react'
// import { PAGE_URLS } from '../../constants/hrefLinks'
import { verifyConnector } from '../../server/connector/verifyConnector'
import { transactionConnector } from '../../server/connector/transactionConnector'
import CtaButton from '../../components/ctaButton/CtaButton'
import { PAGE_URLS } from '../../constants/hrefLinks'

function TransactionIssue() {
	const [detailsMissing, setDetailsMissing] = useState<boolean>(false)
	const [transactionStatus, setTransactionStatus] = useState<string>('')
	const [transactionId, setTransactionId] = useState<string>('')

	const [statusUpdated, setStatusUpdated] = useState<boolean>(false)

	useEffect(() => {
		attemptVerify()
	}, [])

	const attemptVerify = () => {
		const querySting: string = window.location.search;
		const urlParams: URLSearchParams = new URLSearchParams(querySting)
		const transactionStatus: string | null = urlParams.get('status')
		const transactionId: string | null = urlParams.get('id')
		const flag: string | null = urlParams.get('flag')

		if (!transactionStatus || !transactionId) {
			setDetailsMissing(true)
		} else {
			setTransactionStatus(transactionStatus)
			setTransactionId(transactionId)
			if (verifyConnector.requestInProgress) {
				console.log('[VerifyEmail] - requestProfile() called while requestInProgress')
			} else {
				if (transactionStatus ) {
					transactionConnector.completeTransactionRequest(transactionId, transactionStatus, flag == 'tip').then((successRequest) => {
						setStatusUpdated(true)
						if (transactionStatus == 'success') {
							window.location.replace(`${PAGE_URLS.TRANSACTION_SUCCESS}?id=${transactionId}`)
						}
					})
				}
			}
		}
	}
	
	return (
		<>
			<div className='section-wrap section-seperator'>
				<HeaderSolid />
			</div>
			<div className='section-wrap section-seperator'>
				<div className='section-content'>
				<div className='thank-you-content'>
						<div className='sign-up-content-section'>
							<div className='thank-you-message-wrap'>
								{
									detailsMissing === true ? 
										<div className='thank-you-message'>Issue with transaction, contact support</div>
									:
									<div className='thank-you-message'>
										<>Transaction Failed</>
										{statusUpdated ?
										<>
											<div className='sign-up-form-label-txt'>
												Transaction Status: {transactionStatus}
											</div>
											{`Transaction ID: "${transactionId}"`}
										</>
										:
										<>Updating Transaction...</>
										}
									</div>
								}
								<div className='thank-you-button-wrap'>
									<CtaButton
										label='Back to Home'
										onClick={() => {
											window.location.replace(PAGE_URLS.SEARCH)
										}}
										size='medium'
										fullWidth={true}
									/>
									<CtaButton
										label='Dashboard'
										onClick={() => {
											window.location.replace(PAGE_URLS.DASHBOARD_CUSTOMER)
										}}
										size='medium'
										fullWidth={true}
									/>
								</div>
							</div>
						</div>
						<div className='sign-up-content-section'>
							<img
								className='sign-up-picture'
								alt='Ski Lift'
								src='/imgs/pictures/ski-lift.png'
							/>
						</div>
					</div>
				</div>
			</div>
			<div className='section-wrap section-seperator'>
				<div className='section-content'>
					<Footer />
				</div>
			</div>
			<BackToTopButton />
		</>
	)
}

export default TransactionIssue
